/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
// Debounce helper function
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

Shopify.theme.jsFeaturedCollection = {
    init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider($section);
    }
  },

  createSlider: function($section) {
    const sectionSettings = Shopify.theme.getSectionData($section);

    let featuredCollectionSlider = $section.find('.slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true,
      sliderAlign: this.slider_align
    }

     // Calculate initial index based on alignment and viewport
      //OJO: esto solo funciona al inicializar el slider, si se
      //cambia de tamaño de pantalla no se actualiza
     const isDesktop = window.innerWidth >= 768;
     let initialIndex = 0;
     
     if (slideData.sliderAlign === 'left' && isDesktop) {
       initialIndex = Math.floor((slideData.products_per_slide - 1) / 2);
     }

    const flickityOptions = {
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: slideData.wrapAround,
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      initialIndex: initialIndex,
      on: {
        ready: function() {
          $(featuredCollectionSlider).on('settle.flickity', function() {
            $(featuredCollectionSlider).flickity('resize')
          });
          // New height calculation and resize handler
          const setUniformHeights = () => {
            let maxHeight = 0;
            $('.gallery-cell', featuredCollectionSlider).each(function() {
              const $slide = $(this);
              $slide.css('height', ''); // Reset height for recalculation
              maxHeight = Math.max(maxHeight, $slide.outerHeight());
            }).css('height', maxHeight + 'px');
            
            $(featuredCollectionSlider).flickity('resize');
          };

          // Initial calculation
          setUniformHeights();
          
          // Responsive recalculation with debounce
          const debouncedResize = debounce(setUniformHeights, 150);
          $(window).on('resize', debouncedResize);
          
          // Store reference for cleanup
          featuredCollectionSlider.data('resizeHandler', debouncedResize);
        }
      }
    };

    // Add custom navigation if old style is disabled
    if (sectionSettings.navigation_old_style === false) {
      const flickityInstance = $(featuredCollectionSlider).flickity(flickityOptions).data('flickity');
      
      // Custom previous button
      $section.find('.js-featured-collection-prev').on('click', function() {
        flickityInstance.previous();
      });
      
      // Custom next button
      $section.find('.js-featured-collection-next').on('click', function() {
        flickityInstance.next();
      });
    } else {
      // Enable default buttons if products limit allows
      flickityOptions.prevNextButtons = slideData.products_limit > slideData.products_per_slide;
      flickityOptions.arrowShape = arrowShape;
      $(featuredCollectionSlider).flickity(flickityOptions);
    }

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    const resizeHandler = $slider.data('resizeHandler');
    if (resizeHandler) {
      $(window).off('resize', resizeHandler);
    }
    $slider.flickity('destroy');
  }
}

/******/ })()
;